import * as TypeGraphQL from "type-graphql";
export var TradeExitReason;
(function (TradeExitReason) {
    TradeExitReason["STOP_LOSS"] = "STOP_LOSS";
    TradeExitReason["TAKE_PROFIT"] = "TAKE_PROFIT";
    TradeExitReason["TRAILING_STOP"] = "TRAILING_STOP";
    TradeExitReason["MANUAL_EXIT"] = "MANUAL_EXIT";
    TradeExitReason["TIME_EXIT"] = "TIME_EXIT";
    TradeExitReason["MARKET_CLOSE"] = "MARKET_CLOSE";
    TradeExitReason["SIGNAL_REVERSAL"] = "SIGNAL_REVERSAL";
    TradeExitReason["RISK_MANAGEMENT"] = "RISK_MANAGEMENT";
})(TradeExitReason || (TradeExitReason = {}));
TypeGraphQL.registerEnumType(TradeExitReason, {
    name: "TradeExitReason",
    description: undefined,
});
//# sourceMappingURL=TradeExitReason.js.map